import styled, { css } from 'styled-components';

import { Col as BaseColumn } from '@/components/Col';
import { Row } from '@/components/Row';

import { FreeTextContent } from '../FreeTextContent';
import { Heading } from '../Heading';
import { PlaceholderService } from '../PlaceholderService';

export const Wrapper = styled(Row)`
  ${({ theme }) => css`
    ${theme.media.md.down} {
      gap: ${theme.spacing(2)};
    }
  `}
`;

export const Col = styled(BaseColumn)`
  height: 100%;
`;

export const PlaceholderServiceStyled = styled(PlaceholderService)`
  height: 100%;
`;

export const HeadingStyled = styled(Heading)`
  height: 100%;
`;

export const FreeTextContentStyled = styled(FreeTextContent)`
  height: 100%;
`;
